import React from 'react'
import ParameterValue from 'components/ParameterValue'
import PropTypes from 'prop-types'
import { Tooltip } from 'components/patterns'
import { useSelector } from 'react-redux'
import strings from 'utils/strings'
import { Icon } from 'components/patterns/Icon/Icon'
import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { hasRight } from 'selectors/authorization'
import { CREATE_FEATURE_REVISION } from 'constants/authorization'
import { CreateFeatureRevisionButton, useFeatureRevision } from '.'

export default function FeatureRevisionParameter({ featureId }) {
  const revision = useFeatureRevision(featureId)

  // Check if user has permission to create revisions
  const canCreateRevision = useSelector(
    (state) =>
      hasRight(state, CREATE_FEATURE_REVISION.INTERNAL_MODULES) ||
      hasRight(state, CREATE_FEATURE_REVISION.CUSTOM_MODULES)
  )

  return (
    <>
      <span>
        <ParameterValue
          value={revision}
          label={strings.revision}
          size="small"
        />
        {canCreateRevision && (
          <Tooltip
            position="top"
            trigger="hover"
            title={strings.revision_create_tooltip}
          >
            {' '}
            <StyledIcon icon="tooltip-question-circle" size="small" />
          </Tooltip>
        )}
      </span>
      <CreateFeatureRevisionButton featureId={featureId} />
    </>
  )
}

FeatureRevisionParameter.propTypes = {
  featureId: PropTypes.string,
}

const StyledIcon = styled(Icon)`
  width: 15px;
  height: 15px;

  path:first-of-type {
    fill: ${themeColor('whitePrimary')};
  }

  path:nth-of-type(2) {
    fill: ${themeColor('bluePrimary')};
  }

  path:last-of-type {
    fill: ${themeColor('slateLight')};
  }
`
